export default "__VITE_ASSET__BGUm_255__"